// extracted by mini-css-extract-plugin
export default {"background":"ResetEmail_background__bW7kW","form":"ResetEmail_form__6p+MG","close":"ResetEmail_close__v8H9K","container":"ResetEmail_container__dgr-E"};